export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind, Message} from 'kpc';

interface Props {
    value?: string
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: ''};
    }

    @bind
    handleNewChat() {
        this.set('value', '');
        Message.success('已开启新对话');
    }
}